module.exports = __webpack_public_path__ + "img/calculator-style-2.0c0fe267.png";